/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import SpinnerLoaderView from '@airasia-phoenix/react-native/components/SpinnerLoaderView';
import { SpinnerLoaderViewStyle } from '@airasia-phoenix/react-native/components/SpinnerLoaderView/types';
import { pd } from '@airasia-phoenix/react-native/utils';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';
import React from 'react';
import {
  type StyleProp,
  View,
  type ViewStyle,
  type ViewProps,
} from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

export interface FullScreenLoaderOverlayViewProps {
  visible: boolean;
  backgroundColor?: string;
  pointerEvents?: ViewProps['pointerEvents'];
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

export function FullScreenLoaderOverlayView({
  visible,
  backgroundColor = getColor(pd.sys.colour.overlay),
  pointerEvents,
  style,
  testID = 'FullScreenLoaderOverlayView',
}: FullScreenLoaderOverlayViewProps) {
  if (!visible) {
    return null;
  }

  return (
    <View
      style={[styles.overlay, { backgroundColor }, style]}
      pointerEvents={pointerEvents}
      testID={testID}
    >
      <SpinnerLoaderView spinnerStyle={SpinnerLoaderViewStyle.SPINNER} />
    </View>
  );
}

const styles = StyleSheet.create(() => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
}));
